export const CATEGORY_RANKING_TYPE = Object.freeze({
  FREE: 'FREE',
  GROSSING: 'GROSSING',
  PAID: 'PAID',
})

export const CATEGORY_RANKING_FREQUENCY = Object.freeze({
  HOURLY: 'HOURLY',
  DAILY: 'DAILY',
})

export const CHART_AXIS_SCALE = Object.freeze({
  LINEAR: 'LINEAR',
  LOGARITHMIC: 'LOGARITHMIC',
})
